import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
const opts = {

    theme: {
		themes: {
			light: {
				accent: '#E61F31',
				secondary: '#FF4500',
			},
			dark: {
				accent: '#E61F31',
				secondary: '#FF4500',
			}
		}
    },
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    }
}
export default new Vuetify(opts);
 